import IApplicationError from './IApplicationError';
import IKeyValue from './IKeyValue';

export default class ApplicationError extends Error implements IApplicationError {
  public code: string | null;
  constructor(error: IApplicationError) {
    super(error.message);
    this.code = error.code;
    Object.assign(this, error); // tslint:disable-line:prefer-object-spread
  }

  public toJSON() {
    const alt: IKeyValue = {};

    Object.getOwnPropertyNames(this).forEach((key) => {
      if (key === 'stack') {
        return;
      }
      alt[key] = (this as unknown as IKeyValue)[key];
    }, this);

    return alt;
  }
}
